import { Component } from '@angular/core';
/**
 * Geomap icon component declaration, responsible for displaying the icon for geomap in vis-type selection
 */
@Component({
  selector: 'mav-geomap-icon',
  templateUrl: './geomap-icon.component.html',
  styleUrls: ['./geomap-icon.component.scss']
})
export class GeomapIconComponent { }
